import React, { useState, useEffect } from "react";
import "../../../styles/calculate.css";
import axios from "axios";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';
import { useNavigate } from "react-router-dom";
import { catchError } from '../../helpers/catch-error';


const ContractList = () => {

    const navigate = useNavigate();
    const [pageLoad, setPageLoad] = useState(true);
    const [contracts, setContracts] = useState(null);
    const [editMode, setEditMode] = useState(0);
    const [selectedContracts, setSelectedContracts] = useState([]);


    const [perDiemHousing, setPerDiemHousing] = useState({});
    const [perDiemMeals, setPerDiemMeals] = useState({});
    const [perDiemOthers, setPerDiemOthers] = useState({});
    const [perDiemTotal, setPerDiemTotal] = useState({});

    const [isBtn, setIsBtn] = useState(false);
    const social_security_tax = 6.2;
    const medicare_tax = 1.45;


    useEffect(() => {

        document.title = 'Roam Pays: Contracts';
        window.scrollTo(0, 0)

        getContracts();

    }, []);





    const getContracts = async (is_per_diems = 1) => {

        axios.get(process.env.REACT_APP_API_URL + "/get-contracts/", {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(async function (response) {

                if (response?.data?.status) {

                    const cs = response.data.contracts;
                    let contracts = [];
                    let cities = [];
                    let stars = 0;

                    let max_houses = {};
                    let max_meals = {};
                    let max_others = {};
                    let max_total = {};

                    cs.forEach(c => {

                        if (c.location_id > 0 && c.duration > 0 && c.hourly_rate > 0 && c.shift_schedule_id > 0) {

                            let contract = {

                                contract_id: c.contract_id,
                                state: c.state_abbreviation,
                                city: c.city,
                                star: c.star,
                                total_income: (c.hours * c.days * c.hourly_rate * c.duration) + c?.total_stipend * 1 + c.total_benefit * 1 + c.total_bonus * 1,
                                hourly_rate: c.hourly_rate,
                                overtime: c.overtime,
                                meals: c.meals,
                                housing: c.housing,
                                total: c.total,
                                duration: c.duration,
                                weekly_pay: c.hours * c.days * c.hourly_rate,
                                weekly_benefit: c.total_benefit,
                                weekly_bonus: c.total_bonus,
                                weekly_stipend: c.total_stipend,
                                days: c.days,
                                hours: c.hours,
                                key: c.city + "," + c.state,
                                yearly_pay: (c.hours * c.days * c.hourly_rate * 52.1429).toFixed(2),


                            }



                            const federal_tax = c?.federal_tax;
                            const state_tax = c?.state_tax;

                            const federal_tax_amount = (federal_tax / 100 * contract?.weekly_pay)
                            const state_tax_amount = (state_tax / 100 * contract.weekly_pay);
                            const social_security_tax_amount = social_security_tax / 100 * contract.weekly_pay
                            const medicare_tax_amount = medicare_tax / 100 * contract.weekly_pay
                            const weekly_taxes = federal_tax_amount + state_tax_amount + social_security_tax_amount + medicare_tax_amount
                            //  alert(medicare_tax_amount);
                            contract.weekly_taxes = weekly_taxes;



                            if (c.star == 1)
                                stars++;

                            //console.log(parseFloat(c.total_benefit));
                            contracts.push(contract);
                            if (c.housing_max > 0 && c.meals_max > 0) {

                                max_houses[c.city + "," + c.state_abbreviation] = c.housing_max;
                                max_meals[c.city + "," + c.state_abbreviation] = c.meals_max;
                                max_others[c.city + "," + c.state_abbreviation] = c.others_max;
                                max_total[c.city + "," + c.state_abbreviation] = c.housing_max + c.meals_max + c.others_max;

                            }
                            else if (!cities.includes(c.city + "," + c.state_abbreviation)) {
                                cities.push(c.city + "," + c.state_abbreviation + "," + c.contract_id);
                            }


                        }
                    })
                    setContracts(contracts);
                    setPageLoad(false);

                    if (is_per_diems == 1) {


                        for (const city of cities) {
                            const c = city.split(",");
                            const per_diems = await getPerDiem(c[0], c[1], c[2]);
                            console.log(c);
                             console.log(per_diems);
                            max_houses[city] = per_diems[0];
                            max_meals[city] = per_diems[1];
                            max_others[city] = per_diems[2];
                            max_total[city] = per_diems[0] + per_diems[1] + per_diems[2];

                        };

                        setPerDiemHousing(max_houses);
                        setPerDiemMeals(max_meals);
                        setPerDiemOthers(max_others);
                        setPerDiemTotal(max_total);

                    }

                }
                setPageLoad(false);
            })
            .catch(function (error) {
                 catchError(error, navigate);
            });
    }


    const getPerDiem = async (city, state, contract_id) => {
    const year = new Date().getFullYear();
    const month = new Date().getMonth(); // 0-based
    const normalizedCity = city ? city.trim().toLowerCase() : "";

    const p1 = new Promise((resolve, reject) => {
        axios
            .get(
                `https://api.gsa.gov/travel/perdiem/v2/rates/city/${encodeURIComponent(city)}/state/${state}/year/${year}?API_KEY=${process.env.REACT_APP_GSA_API_KEY}`,
                { headers: {} }
            )
            .then((r) => {
                const rates = r?.data?.rates;
                if (!rates?.length) return resolve([0, 0]);

                const rateEntries = rates[0]?.rate;
                if (!rateEntries?.length) return resolve([0, 0]);

                // Case-insensitive city match
                const matchedRate = rateEntries.find(rt =>
                    rt?.city?.toLowerCase().includes(normalizedCity)
                );

                // Fallback: first entry if no match
                const selectedRate = matchedRate || rateEntries[0];

                const housing =
                    selectedRate?.months?.month?.[month]?.value ?? 0;

                const meals = selectedRate?.meals ?? 0;

                resolve([meals, housing]);
            })
            .catch((err) => {
                reject(err);
            });
    });

    const p2 = new Promise((resolve, reject) => {
        axios
            .get(
                `https://api.gsa.gov/travel/perdiem/v2/rates/conus/mie/${year}?API_KEY=${process.env.REACT_APP_GSA_API_KEY}`,
                { headers: {} }
            )
            .then((r) => {
                const rate = r?.data?.[0];
                const others = rate?.incidental ?? 0;
                resolve([others]);
            })
            .catch((err) => {
                reject(err);
            });
    });

    const pa = await Promise.all([p1, p2])
        .then((values) => {
            const meals = values[0][0];
            const housing = values[0][1];
            const others = values[1][0];

            axios.post(
                process.env.REACT_APP_API_URL + "/save-max-allowances-by-id/",
                {
                    contract_id: contract_id,
                    housing_max: housing,
                    meals_max: meals,
                    others_max: others,
                },
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: true,
                }
            );

            return [housing, meals, others];
        })
        .catch((error) => {
            setPageLoad(false);
            console.log(error);
            return [0, 0];
        });

    return pa;
};




    const updateStar = async (contract_id, star) => {

        //alert("called"+"--"+contract_id+"--"+star);
        axios.post(process.env.REACT_APP_API_URL + "/update-star/", {
            contract_id: contract_id,
            star: star == 0 ? 1 : 0,
        },
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
            .then(async function (response) {

                if (response?.data?.status) {

                    getContracts(0);


                }
                setPageLoad(false);
            })
            .catch(function (error) {
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Error", text: error.message });
            });
    }




    const deleteStar = async () => {

        setIsBtn(true);
        axios.post(process.env.REACT_APP_API_URL + "/remove-contracts-by-ids/", {
            contract_ids: selectedContracts,
        },
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
            .then(async function (response) {

                setIsBtn(false);
                if (response?.data?.status) {

                    getContracts(0);
                    setSelectedContracts([]);



                }
                setPageLoad(false);
            })
            .catch(function (error) {
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Error", text: error.message });
            });
    }



    const deleteAll = async () => {

        //alert("called"+"--"+contract_id+"--"+star);
        setIsBtn(true);
        axios.post(process.env.REACT_APP_API_URL + "/delete-contracts-all/", {},
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            })
            .then(async function (response) {

                setIsBtn(false);
                if (response?.data?.status) {

                    getContracts(0);


                }
                setPageLoad(false);
            })
            .catch(function (error) {
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Error", text: error.message });
            });
    }

    const handleSelectionChange = (id) => {

        // console.log(e.target.checked);
        if (selectedContracts.indexOf(id) === -1) {
            setSelectedContracts([...selectedContracts, id]);
        } else {
            setSelectedContracts(selectedContracts.filter((s) => s != id));
        }
    };



    return (
        <>
            <div className="title-box">
                <div className="flex-equal" ></div>
                <h3 className="flex-equal justify-content-center fs-32 fs-helvetica color-white lg">Contracts</h3>
                <div className="flex-equal justify-content-end" >
                    {contracts?.length > 0 &&
                        <>
                            {editMode ?
                                <button className="btn btn-link" onClick={() => { setEditMode(false); setSelectedContracts([]); }}  >Done</button>
                                :
                                <button className="btn btn-link" onClick={() => { setEditMode(true); setSelectedContracts([]); }} >Edit</button>
                            }
                        </>
                    }

                </div>

            </div>
            {pageLoad ?

                <div className="box g-32"><Loading color={'#75f'} stroke={'20px'} size={'200px'} /></div>

                :
                <>
                    <div className=" box g-32" >

                        {contracts && contracts.map((c, index) => {
                            return (
                                <> {!editMode ?

                                    <div className={" card " + ((index == 0 && contracts?.length > 1) ? "best" : "") + ((selectedContracts.indexOf(c.contract_id) !== -1) ? " selected-card" : "")}  >
                                        <div className="card-title align-items-center" >

                                            <div className="box-title color-white fs-18 fs-helvetica d-flex" >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M11.9999 2C8.17296 2 5.05957 5.11385 5.05957 8.94089C5.05957 12.6248 11.3567 21.2316 11.6248 21.596L11.875 21.9366C11.9043 21.9766 11.9509 22 11.9999 22C12.0497 22 12.096 21.9766 12.1256 21.9366L12.3756 21.596C12.6439 21.2316 18.9408 12.6248 18.9408 8.94089C18.9408 5.11385 15.827 2 11.9999 2ZM11.9999 6.45468C13.3711 6.45468 14.4861 7.56974 14.4861 8.94089C14.4861 10.3113 13.3711 11.4271 11.9999 11.4271C10.6295 11.4271 9.51369 10.3113 9.51369 8.94089C9.51369 7.56974 10.6295 6.45468 11.9999 6.45468Z" fill="white" />
                                                </svg>
                                                {c.city}, {c.state}


                                            </div>

                                            <span className="cursor-pointer" onClick={() => { updateStar(c?.contract_id, c.star) }} >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                                    <path d="M16 5.30198L18.7124 11.8233L18.8297 12.1053L19.1341 12.1297L26.1744 12.6941L20.8104 17.289L20.5785 17.4876L20.6493 17.7847L22.2881 24.6549L16.2606 20.9733L16 20.8141L15.7394 20.9733L9.71186 24.6549L11.3506 17.7847L11.4215 17.4876L11.1896 17.289L5.82558 12.6941L12.8659 12.1297L13.1703 12.1053L13.2876 11.8233L16 5.30198Z" fill={c.star ? "#FCBF04" : "#292929"} stroke="#464646" />
                                                </svg>

                                            </span>

                                            <div className="hr-div" >

                                                <hr />
                                            </div>


                                        </div>
                                        <a href={"/contract/edit/" + c.contract_id} className="cursor-pointer align-self-stretch"  >

                                            <div className="card-content" >


                                                <div className="input-container" >
                                                    <div className="fd-row align-self-stretch" >

                                                        <div className="color-white fs-14 mr-3" >${(c.weekly_pay + c.weekly_stipend).toFixed(0)} </div>
                                                        {(c.hourly_rate > 0) &&
                                                            <div className="fd-row flex-grow-1">
                                                                <div className="align-self-center segment segment-green " style={{ flexBasis: ((c.weekly_pay - c.weekly_taxes) * 100 / (c.weekly_pay + c.weekly_stipend)).toFixed(0) + "%" }} ></div>
                                                                <div className="align-self-center segment segment-brown " style={{ flexBasis: ((c.weekly_taxes) * 100 / (c.weekly_pay + c.weekly_stipend)).toFixed(0) + "%" }} ></div>
                                                                <div className="align-self-center segment segment-purple" style={{ flexBasis: (c.weekly_stipend * 100 / (c.weekly_pay + c.weekly_stipend)).toFixed(0) + "%" }}></div>
                                                            </div>
                                                        }
                                                    </div>


                                                </div>


                                                <div className="fd-row g-12 align-self-stretch" >
                                                    <div className="input-container" >
                                                        <div className="input-box fd-column align-items-start  g-4" >
                                                            <label className="color-white fs-14">${c?.hourly_rate ? c.hourly_rate.toFixed(2) : 0.00}</label>
                                                            <label className="fs-12 color-lighter">Hourly Rate</label>
                                                        </div>
                                                    </div>

                                                    <div className="input-container" >

                                                        <div className="input-box fd-column  align-items-start g-4" >
                                                            <label className="color-white fs-14">${c?.overtime ? c.overtime.toFixed(2) : 0.00}</label>
                                                            <label className="fs-12 color-lighter">Overtime</label>
                                                        </div>


                                                    </div>
                                                </div>

                                                <div className="input-container" >

                                                    <div className="input-box fd-column  align-items-stretch g-4" >



                                                        <div className="fd-row align-items-center">
                                                            <div className="fd-column flex-grow-1">
                                                                <label className="color-white fs-14">${c?.housing ? (c.housing.toFixed(2)) : 0.00} </label>
                                                                <label className="fs-12 color-lighter">Housing</label>
                                                            </div>
                                                            <button className="btn btn-sm btn-secondary fd-row align-items-center g-8">
                                                                {!perDiemHousing[c.city + "," + c.state] ?
                                                                    <Loading size={'20px'} color={'#75f'} />
                                                                    :

                                                                    <>
                                                                        <div className="p-8 d-flex fs-12 justify-content-end color-light" >
                                                                            <label >Maximum Allowance: <span className="color-white  ">${(7 * perDiemHousing[c.city + "," + c.state]).toFixed(2)}</span></label>

                                                                        </div>
                                                                        {((c.housing) == (7 * perDiemHousing[c.city + "," + c.state])) ?
                                                                            <>
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00033 12.8334C10.222 12.8334 12.8337 10.2217 12.8337 7.00008C12.8337 3.77842 10.222 1.16675 7.00033 1.16675C3.77866 1.16675 1.16699 3.77842 1.16699 7.00008C1.16699 10.2217 3.77866 12.8334 7.00033 12.8334ZM5.14363 6.33093L4.31867 7.15588L6.38107 9.21828L9.6809 5.91845L8.85594 5.09349L6.38107 7.56836L5.14363 6.33093Z" fill="#BDEA5C" />
                                                                                </svg>
                                                                                <label>Maxed Out</label>
                                                                            </>
                                                                            :
                                                                            <>
                                                                                {((c.housing) > (7 * perDiemHousing[c.city + "," + c.state])) ?
                                                                                    <>
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43433 1.16675H5.62116L0.291992 10.3971L1.69858 12.8334H12.3569L13.7635 10.3971L8.43433 1.16675ZM7.61111 4.66675V8.16675H6.44444V4.66675H7.61111ZM7.61111 9.33341L7.61111 10.5001L6.44445 10.5001L6.44444 9.33342L7.61111 9.33341Z" fill="#FFED48" />
                                                                                        </svg>
                                                                                        <label>${((c.housing) - (7 * perDiemHousing[c.city + "," + c.state]))} Over</label>
                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43433 1.16675H5.62116L0.291992 10.3971L1.69858 12.8334H12.3569L13.7635 10.3971L8.43433 1.16675ZM7.61111 4.66675V8.16675H6.44444V4.66675H7.61111ZM7.61111 9.33341L7.61111 10.5001L6.44445 10.5001L6.44444 9.33342L7.61111 9.33341Z" fill="#FF9696" />
                                                                                        </svg>
                                                                                        <label>${((7 * perDiemHousing[c.city + "," + c.state]) - (c.housing))} Under</label>
                                                                                    </>
                                                                                }
                                                                            </>
                                                                        }
                                                                    </>
                                                                }
                                                            </button>
                                                        </div>
                                                        <div className="" >
                                                            <hr className="hr-grey" />
                                                        </div>

                                                        <div className="fd-row align-items-center">
                                                            <div className="fd-column flex-grow-1">
                                                                <label className="color-white fs-14">${c?.meals ? (c.meals.toFixed(2)) : 0.00}</label>
                                                                <label className="fs-12 color-lighter">Meals</label>
                                                            </div>
                                                            <button className="btn btn-sm btn-secondary fd-row align-items-center g-8">
                                                                {!perDiemMeals[c.city + "," + c.state] ?
                                                                    <Loading size={'20px'} color={'#75f'} />
                                                                    :
                                                                    <>
                                                                        <div className="p-8 d-flex fs-12 justify-content-end color-light" >
                                                                            <label >Maximum Allowance: <span className="color-white  ">${(7 * perDiemMeals[c.city + "," + c.state]).toFixed(2)}</span></label>

                                                                        </div>
                                                                        {((c.meals) == (7 * perDiemMeals[c.city + "," + c.state])) ?
                                                                            <>
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00033 12.8334C10.222 12.8334 12.8337 10.2217 12.8337 7.00008C12.8337 3.77842 10.222 1.16675 7.00033 1.16675C3.77866 1.16675 1.16699 3.77842 1.16699 7.00008C1.16699 10.2217 3.77866 12.8334 7.00033 12.8334ZM5.14363 6.33093L4.31867 7.15588L6.38107 9.21828L9.6809 5.91845L8.85594 5.09349L6.38107 7.56836L5.14363 6.33093Z" fill="#BDEA5C" />
                                                                                </svg>
                                                                                <label>Maxed Out</label>
                                                                            </>
                                                                            :
                                                                            <>
                                                                                {((c.meals) > (7 * perDiemMeals[c.city + "," + c.state])) ?
                                                                                    <>
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43433 1.16675H5.62116L0.291992 10.3971L1.69858 12.8334H12.3569L13.7635 10.3971L8.43433 1.16675ZM7.61111 4.66675V8.16675H6.44444V4.66675H7.61111ZM7.61111 9.33341L7.61111 10.5001L6.44445 10.5001L6.44444 9.33342L7.61111 9.33341Z" fill="#FFED48" />
                                                                                        </svg>
                                                                                        <label>${((c.meals) - (7 * perDiemMeals[c.city + "," + c.state]))} Over</label>
                                                                                    </>
                                                                                    :
                                                                                    <>
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43433 1.16675H5.62116L0.291992 10.3971L1.69858 12.8334H12.3569L13.7635 10.3971L8.43433 1.16675ZM7.61111 4.66675V8.16675H6.44444V4.66675H7.61111ZM7.61111 9.33341L7.61111 10.5001L6.44445 10.5001L6.44444 9.33342L7.61111 9.33341Z" fill="#FF9696" />
                                                                                        </svg>
                                                                                        <label>${((7 * perDiemMeals[c.city + "," + c.state]) - (c.meals))} Under</label>
                                                                                    </>
                                                                                }
                                                                            </>
                                                                        }
                                                                    </>
                                                                }

                                                            </button>
                                                        </div>

                                                    </div>

                                                </div>

                                                <div class="fd-row g-12 align-self-stretch">


                                                    <div className="input-container" >

                                                        <div className="input-box fd-column align-items-start  g-4" >
                                                            <label className="color-white fs-14">{c?.days ? c?.days + "*" : ""}{c?.hours}</label>
                                                            <label className="fs-12 color-lighter">Shift Schedule</label>
                                                        </div>
                                                    </div>
                                                    <div className="input-container" >

                                                        <div className="input-box fd-column align-items-start  g-4" >
                                                            <label className="color-white fs-14">{c.duration} Weeks</label>
                                                            <label className="fs-12 color-lighter">Duration</label>
                                                        </div>
                                                    </div>
                                                    <div className="input-container" >

                                                        <div className="input-box fd-column align-items-start  g-4" >
                                                            <label className="color-white fs-14">${c.weekly_bonus}</label>
                                                            <label className="fs-12 color-lighter">Bonus</label>
                                                        </div>
                                                    </div>


                                                </div>



                                            </div>

                                            {index == 0 && contracts?.length > 1 &&
                                                <div className="btn btn-out btn-bottom fs-14" >Best Contract</div>
                                            }

                                        </a>
                                    </div>
                                    :
                                    <div className={" card cursor-pointer" + ((selectedContracts.indexOf(c.contract_id) !== -1) ? " selected-card" : "")}  >
                                        <div className="card-title align-items-center cursor-pointer" onClick={() => handleSelectionChange(c.contract_id)} >

                                            <div className="box-title color-white fs-18 fs-helvetica d-flex" >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M11.9999 2C8.17296 2 5.05957 5.11385 5.05957 8.94089C5.05957 12.6248 11.3567 21.2316 11.6248 21.596L11.875 21.9366C11.9043 21.9766 11.9509 22 11.9999 22C12.0497 22 12.096 21.9766 12.1256 21.9366L12.3756 21.596C12.6439 21.2316 18.9408 12.6248 18.9408 8.94089C18.9408 5.11385 15.827 2 11.9999 2ZM11.9999 6.45468C13.3711 6.45468 14.4861 7.56974 14.4861 8.94089C14.4861 10.3113 13.3711 11.4271 11.9999 11.4271C10.6295 11.4271 9.51369 10.3113 9.51369 8.94089C9.51369 7.56974 10.6295 6.45468 11.9999 6.45468Z" fill="white" />
                                                </svg>
                                                {c.city}, {c.state}


                                            </div>

                                            <span className="cursor-pointer" onClick={() => { updateStar(c?.contract_id, c.star) }} >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                                    <path d="M16 5.30198L18.7124 11.8233L18.8297 12.1053L19.1341 12.1297L26.1744 12.6941L20.8104 17.289L20.5785 17.4876L20.6493 17.7847L22.2881 24.6549L16.2606 20.9733L16 20.8141L15.7394 20.9733L9.71186 24.6549L11.3506 17.7847L11.4215 17.4876L11.1896 17.289L5.82558 12.6941L12.8659 12.1297L13.1703 12.1053L13.2876 11.8233L16 5.30198Z" fill={c.star ? "#FCBF04" : "#292929"} stroke="#464646" />
                                                </svg>

                                            </span>

                                            <div className="hr-div" >

                                                <hr />
                                            </div>


                                        </div>
                                        <div className="card-content cursor-pointer" onClick={() => handleSelectionChange(c.contract_id)} >


                                            <div className="input-container" >
                                                <div className="fd-row align-self-stretch" >

                                                    <div className="color-white fs-14 mr-3" >${(c.weekly_pay - c.weekly_taxes).toFixed(0)} </div>
                                                    {(c.duration > 0 && c.hourly_rate > 0) &&
                                                        <div className="fd-row flex-grow-1">
                                                            <div className="align-self-center segment segment-green " style={{ flexBasis: ((c.weekly_pay - c.weekly_taxes) * 100 / (c.weekly_pay + c.weekly_stipend)).toFixed(0) + "%" }} ></div>
                                                            <div className="align-self-center segment segment-brown " style={{ flexBasis: (c.weekly_taxes * 100 / (c.weekly_pay + c.weekly_stipend)).toFixed(0) + "%" }}  ></div>
                                                            <div className="align-self-center segment segment-purple" style={{ flexBasis: (c.weekly_stipend * 100 / (c.weekly_pay + c.weekly_stipend)).toFixed(0) + "%" }}></div>
                                                        </div>
                                                    }
                                                </div>


                                            </div>


                                            <div className="fd-row g-12 align-self-stretch" >
                                                <div className="input-container" >
                                                    <div className="input-box fd-column align-items-start  g-4" >
                                                        <label className="color-white fs-14">${c?.hourly_rate ? c.hourly_rate.toFixed(2) : 0.00}</label>
                                                        <label className="fs-12 color-lighter">Hourly Rate</label>
                                                    </div>
                                                </div>

                                                <div className="input-container" >

                                                    <div className="input-box fd-column  align-items-start g-4" >
                                                        <label className="color-white fs-14">${c?.overtime ? c.overtime.toFixed(2) : 0.00}</label>
                                                        <label className="fs-12 color-lighter">Overtime</label>
                                                    </div>


                                                </div>
                                            </div>

                                            <div className="input-container" >

                                                <div className="input-box fd-column  align-items-stretch g-4" >

                                                    <div className="fd-row align-items-center">
                                                        <div className="fd-column flex-grow-1">
                                                            <label className="color-white fs-14">${c?.housing ? c.housing.toFixed(2) : 0.00} </label>
                                                            <label className="fs-12 color-lighter">Housing</label>
                                                        </div>
                                                        <button className="btn btn-sm btn-secondary fd-row align-items-center g-8">
                                                            {!perDiemHousing[c.city + "," + c.state] ?
                                                                <Loading size={'20px'} color={'#75f'} />
                                                                :

                                                                <>
                                                                    <div className="p-8 d-flex fs-12 justify-content-end color-light" >
                                                                        <label >Maximum Allowance: <span className="color-white  ">${(7 * perDiemHousing[c.city + "," + c.state]).toFixed(2)}</span></label>

                                                                    </div>
                                                                    {(c.housing == (7 * perDiemHousing[c.city + "," + c.state])) ?
                                                                        <>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00033 12.8334C10.222 12.8334 12.8337 10.2217 12.8337 7.00008C12.8337 3.77842 10.222 1.16675 7.00033 1.16675C3.77866 1.16675 1.16699 3.77842 1.16699 7.00008C1.16699 10.2217 3.77866 12.8334 7.00033 12.8334ZM5.14363 6.33093L4.31867 7.15588L6.38107 9.21828L9.6809 5.91845L8.85594 5.09349L6.38107 7.56836L5.14363 6.33093Z" fill="#BDEA5C" />
                                                                            </svg>
                                                                            <label>Maxed Out</label>
                                                                        </>
                                                                        :
                                                                        <>

                                                                            {(c.housing > (7 * perDiemHousing[c.city + "," + c.state])) ?
                                                                                <>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43433 1.16675H5.62116L0.291992 10.3971L1.69858 12.8334H12.3569L13.7635 10.3971L8.43433 1.16675ZM7.61111 4.66675V8.16675H6.44444V4.66675H7.61111ZM7.61111 9.33341L7.61111 10.5001L6.44445 10.5001L6.44444 9.33342L7.61111 9.33341Z" fill="#FFED48" />
                                                                                    </svg>
                                                                                    <label>${(c.housing - (7 * perDiemHousing[c.city + "," + c.state]))} Over</label>
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43433 1.16675H5.62116L0.291992 10.3971L1.69858 12.8334H12.3569L13.7635 10.3971L8.43433 1.16675ZM7.61111 4.66675V8.16675H6.44444V4.66675H7.61111ZM7.61111 9.33341L7.61111 10.5001L6.44445 10.5001L6.44444 9.33342L7.61111 9.33341Z" fill="#FF9696" />
                                                                                    </svg>
                                                                                    <label>${((7 * perDiemHousing[c.city + "," + c.state]) - c.housing)} Under</label>
                                                                                </>
                                                                            }
                                                                        </>
                                                                    }
                                                                </>
                                                            }
                                                        </button>
                                                    </div>
                                                    <div className="" >
                                                        <hr className="hr-grey" />
                                                    </div>

                                                    <div className="fd-row align-items-center">
                                                        <div className="fd-column flex-grow-1">
                                                            <label className="color-white fs-14">${c?.meals ? c.meals.toFixed(2) : 0.00}</label>
                                                            <label className="fs-12 color-lighter">Meals</label>
                                                        </div>
                                                        <button className="btn btn-sm btn-secondary fd-row align-items-center g-8">
                                                            {!perDiemMeals[c.city + "," + c.state] ?
                                                                <Loading size={'20px'} color={'#75f'} />
                                                                :
                                                                <>
                                                                    <div className="p-8 d-flex fs-12 justify-content-end color-light" >
                                                                        <label >Maximum Allowance: <span className="color-white  ">${(7 * perDiemMeals[c.city + "," + c.state]).toFixed(2)}</span></label>

                                                                    </div>
                                                                    {(c.meals == (7 * perDiemMeals[c.city + "," + c.state])) ?
                                                                        <>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00033 12.8334C10.222 12.8334 12.8337 10.2217 12.8337 7.00008C12.8337 3.77842 10.222 1.16675 7.00033 1.16675C3.77866 1.16675 1.16699 3.77842 1.16699 7.00008C1.16699 10.2217 3.77866 12.8334 7.00033 12.8334ZM5.14363 6.33093L4.31867 7.15588L6.38107 9.21828L9.6809 5.91845L8.85594 5.09349L6.38107 7.56836L5.14363 6.33093Z" fill="#BDEA5C" />
                                                                            </svg>
                                                                            <label>Maxed Out</label>
                                                                        </>
                                                                        :
                                                                        <>

                                                                            {(c.meals > (7 * perDiemMeals[c.city + "," + c.state])) ?
                                                                                <>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43433 1.16675H5.62116L0.291992 10.3971L1.69858 12.8334H12.3569L13.7635 10.3971L8.43433 1.16675ZM7.61111 4.66675V8.16675H6.44444V4.66675H7.61111ZM7.61111 9.33341L7.61111 10.5001L6.44445 10.5001L6.44444 9.33342L7.61111 9.33341Z" fill="#FFED48" />
                                                                                    </svg>
                                                                                    <label>${(c.meals - (c.days * perDiemMeals[c.city + "," + c.state]))} Over</label>
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43433 1.16675H5.62116L0.291992 10.3971L1.69858 12.8334H12.3569L13.7635 10.3971L8.43433 1.16675ZM7.61111 4.66675V8.16675H6.44444V4.66675H7.61111ZM7.61111 9.33341L7.61111 10.5001L6.44445 10.5001L6.44444 9.33342L7.61111 9.33341Z" fill="#FF9696" />
                                                                                    </svg>
                                                                                    <label>${((7 * perDiemMeals[c.city + "," + c.state]) - c.meals)} Under</label>
                                                                                </>
                                                                            }
                                                                        </>
                                                                    }
                                                                </>
                                                            }

                                                        </button>
                                                    </div>

                                                </div>

                                            </div>

                                            <div class="fd-row g-12 align-self-stretch">

                                                <div className="input-container" >
                                                    <div className="input-box fd-column align-items-start  g-4" >
                                                        <label className="color-white fs-14">${c.weekly_bonus}</label>
                                                        <label className="fs-12 color-lighter">Bonus</label>
                                                    </div>


                                                </div>
                                                <div className="input-container" >

                                                    <div className="input-box fd-column align-items-start  g-4" >
                                                        <label className="color-white fs-14">{c.duration} Weeks</label>
                                                        <label className="fs-12 color-lighter">Duration</label>
                                                    </div>
                                                </div>

                                            </div>


                                        </div>
                                    </div>
                                }
                                </>
                            )
                        }
                        )}


                        <br />
                        <br />
                        <br />
                        <br />



                    </div>
                    {editMode == 1 &&

                        <div className="form-action">

                            <div className="action-bar ">

                                <div className="button-box">

                                    {selectedContracts?.length > 0 &&
                                        <button className="btn btn-secondary" onClick={deleteStar} disabled={isBtn}>
                                            {isBtn ? <Loading size={'20px'} /> : 'Delete (' + selectedContracts?.length + ')'}</button>
                                    }
                                    <button className="btn btn-under" onClick={deleteAll} disabled={isBtn}>
                                        {isBtn ? <Loading size={'20px'} /> : 'Delete All'}</button>

                                </div>

                            </div>

                        </div>
                    }
                </>
            }

        </>


    );
};

export default ContractList;